import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'assets/icons';
import { getGuidesForTrack } from 'app/member/guides';
import { SlideshowModal } from '../slideshow';
import styles from './guides.module.css';

export const Guides = () => {
  const track = useSelector((state) => state.metadata.agency?.track);
  const [active_guide, setActiveGuide] = useState(null);

  // Show only the guides that apply to the partner's track.
  const guides = getGuidesForTrack(track);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.title}>Guides &amp; onboarding</span>
      </div>

      <div className={styles.list}>
        {guides.map((guide) => (
          <button key={guide.id} className={styles.row} onClick={() => setActiveGuide(guide)}>
            <div className={styles.rowBody}>
              <p className={styles.guideTitle}>{guide.title}</p>
              <p className={styles.guideDescription}>{guide.description}</p>
            </div>
            <Icon name="arrow_right" width={14} height={14} className={styles.arrow} />
          </button>
        ))}
      </div>

      <SlideshowModal
        slides={active_guide?.slides || []}
        title={active_guide?.title}
        finish_label="Done"
        reset_key={active_guide?.id}
        show={!!active_guide}
        onClose={() => setActiveGuide(null)}
      />
    </div>
  );
};
